import { format } from 'date-fns';
import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthProvider/AuthProvider';

const Wishlist = ({category_id, product}) => {
    const { user, successMessage } = useContext(AuthContext);
    const { _id, title, resale_price, image, seller_name, seller_email } = product;
    const date = format(new Date(), 'PP');

    const handleWishlist = (event) => {
        event.preventDefault();

        const wishlist = {
            category_id:category_id,
            product_id:_id,
            product_title:title,
            image:image,
            order_status:0,
            payment_status:'pending',
            payment_method:null,
            seller_name:seller_name,
            seller_email:seller_email,
            date:date,
            buyer_name:user.displayName,
            buyer_email:user.email,
            price:resale_price,
            buyer_phone:123456789,
            meeting_location:'Chittagong Bangladesh',
        };

        fetch('https://used-products-resale-market-server.vercel.app/wishlists', {
            method: 'POST',
            headers: {
                'content-type': 'application/json', 
                // authorization: `bearer ${localStorage.getItem('accessToken')}`
            },
            body: JSON.stringify(wishlist)
        })
        .then(res => res.json())
        .then(result =>{
                console.log(result);
                if(result.acknowledged){
                successMessage();
            }
        })
        .catch(err => console.error(err));
    }



    return (
        <form onSubmit={handleWishlist}>
            <div className="d-grid gap-2">
                <button type='submit' className="btn btn-dark">Wishlist</button>
            </div>
        </form>
    );
};

export default Wishlist;